import { memo } from 'react';

import LottieAnimation from '@/shared/components/lottieAnimation/LottieAnimation';

import defaultLoader from './audio-waves-dark-blue.json';

import './audio-waves.scss';

import type { LottieRefCurrentProps } from 'lottie-react';

interface AudioWavesProps {
	lottieRef?: { current: LottieRefCurrentProps | null };
}

const AudioWaves = ({ lottieRef }: AudioWavesProps) => {
	return (
		<div className="audio-waves" aria-hidden="true">
			<LottieAnimation animationData={defaultLoader} className="audio-waves-animate" lottieRef={lottieRef} />
		</div>
	);
};

export default memo(AudioWaves);
